module.exports = {"title":"beer.db - New Repo /maps - Free 'Full-Screen' Interactive Beer Maps w/ Brewery Listings","layout":"post","path":"/posts/new-repo-maps/","body":"<p>The beer.db project - offering free public domain beer, brewery and brewpubs data - added a new repo, that is, <code>/maps</code>\nfor hosting ‘full-screen’ interactive beer maps with brewery listings.</p>\n<p>See an example <a href=\"http://openbeer.github.io/maps/at\">beer map for Austria</a> (~200 breweries n brewpubs)\nlive or <a href=\"https://github.com/openbeer/maps\">check the source</a> using the mapbox.js mapping library.</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./posts/2014-11-11-new-repo-maps.md
 ** module id = 381
 ** module chunks = 0
 **/